import { AxiosInstance } from "@bps/http-client";

import {
  PltCatalogComponentDto,
  PltCatalogPracticeLicenceDto,
  PltCatalogTenantFeaturesDto
} from "./plt-catalog.dtos";
import { IPltCatalogGateway } from "./plt-catalog.gateway.interface";

export class PltCatalogGateway implements IPltCatalogGateway {
  constructor(private api: AxiosInstance) {}

  public getTenantFeatures = async (
    code: string
  ): Promise<PltCatalogTenantFeaturesDto> => {
    return (
      await this.api.get<PltCatalogTenantFeaturesDto>(
        `external/tenantFeatures/${code}`
      )
    ).data;
  };

  public getPracticeLicences = async (): Promise<
    PltCatalogPracticeLicenceDto[]
  > => {
    return (
      await this.api.get<PltCatalogPracticeLicenceDto[]>("users/licences")
    ).data;
  };

  public getComponent = async (
    componentCode: string
  ): Promise<PltCatalogComponentDto> => {
    return (
      await this.api.get<PltCatalogComponentDto>(
        `external/components/${componentCode}`
      )
    ).data;
  };
}
